import React from 'react';
import isNil from '~/_base/functions/isNil';
import { IActionCollapse2, IChevronDown } from '~/_base/components/helixIcons';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import { apiCallWithOptions } from '~/_base/functions/apicalls';
import ApiAddresses from '~/_base/constants/apiAddresses';
import enhanceWithClickOutside from 'react-click-outside';

class FeedFilters extends React.Component {
  constructor(props) {
    super();

    // check if any filters have been saved to the browser's local storage...
    const filters = props.filters;

    const selectedUsers = isNil(filters.users) ? [] : filters.users.split(',');
    const selectedTemplates = isNil(filters.templates)
      ? []
      : filters.templates.split(',');

    // convert the arrays to integers
    const users = selectedUsers.map(item => {
      return parseInt(item);
    });

    const templates = selectedTemplates.map(item => {
      return parseInt(item);
    });

    this.state = {
      gettingTemplates: true,
      selectedTemplate: templates,
      selectedUser: users,
      usersList: [],
      filterSelectorOpen: false,
    };

    this.getTemplates(props.projectId);
    this.getUsers(props.projectId);
  }

  render() {
    const className = this.props.open
      ? 'filtersContainer open'
      : 'filtersContainer';

    return (
      <div className={className}>
        <div className="filterHeader">
          <h1>Filters</h1>
          <IconButton className="filterClose" onClick={() => this.handleClose()} size="large">
            <IActionCollapse2 />
          </IconButton>
        </div>
        <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }} autoComplete="off">
          {this.renderTemplatesControl()}
          {this.renderUsersControl()}
        </Box>
        <div className="filterFooter">
          {!isNil(this.state.selectedUser) ||
          !isNil(this.state.selectedTemplate) ? (
            <Button
              className="filtersClear"
              variant="contained"
              color="secondary"
              onClick={() => this.handleClear()}
            >
              Clear
            </Button>
          ) : null}
        </div>
      </div>
    );
  }

  handleTemplateChange(event) {
    //
    this.setState({ selectedTemplate: event.target.value });
    this.props.actions.queryWithFilters(
      { templates: event.target.value.join() },
      false
    );
  }

  handleUserChange(event) {
    this.setState({ selectedUser: event.target.value });
    this.props.actions.queryWithFilters(
      { users: event.target.value.join() },
      false
    );
  }

  setFilterSelectorOpen(val) {
    console.log('setFilterSelectorOpen', val);
    this.setState({
      filterSelectorOpen: val,
    });
  }

  renderTemplatesControl() {
    return (
      <FormControl variant="standard" sx={{ margin: 1, minWidth: '96%' }}>
        <InputLabel htmlFor="template">Templates</InputLabel>
        <Select
          variant="standard"
          multiple
          value={this.state.selectedTemplate}
          onChange={event => this.handleTemplateChange(event)}
          onOpen={() => this.setFilterSelectorOpen(true)}
          onClose={() => this.setFilterSelectorOpen(false)}
          inputProps={{
            name: 'template',
            id: 'template',
          }}
          IconComponent={IChevronDown}>
          {this.state.templatesList}
        </Select>
      </FormControl>
    );
  }

  renderUsersControl() {
    return (
      <FormControl variant="standard" sx={{ margin: 1, minWidth: '96%' }}>
        <InputLabel htmlFor="users">Users</InputLabel>
        <Select
          variant="standard"
          multiple
          value={this.state.selectedUser}
          onChange={event => this.handleUserChange(event)}
          onOpen={event => this.setFilterSelectorOpen(true)}
          onClose={event => this.setFilterSelectorOpen(false)}
          inputProps={{
            name: 'users',
            id: 'users',
          }}
          IconComponent={IChevronDown}>
          {this.state.usersList}
        </Select>
      </FormControl>
    );
  }

  getTemplates(projectId) {
    const address = ApiAddresses({
      name: 'templates_by_project',
      project_id: projectId,
    });
    let callAPI = apiCallWithOptions(address, 'GET', {
      cacheRequest: true,
    });

    callAPI
      .then(json => {
        this.buildTemplatesList(json);
      })
      .catch(err => {
        console.error(err.message);
      });
  }

  getUsers(projectId) {
    const address = ApiAddresses({
      name: 'users_by_project',
      project_id: projectId,
    });
    let callAPI = apiCallWithOptions(address, 'GET', {
      cacheRequest: true,
    });

    callAPI
      .then(json => {
        this.buildUsersList(json);
      })
      .catch(err => {
        console.error(err.message);
      });
  }

  buildUsersList(data) {
    const users = data.map((item, index) => {
      return (
        <MenuItem key={`user_key${index}`} value={item.user_id}>
          {item.user.name}
        </MenuItem>
      );
    });

    // users.unshift(<MenuItem key={`unselectKey`} value="">
    //         <em>None</em>
    //     </MenuItem>)

    this.setState({ usersList: users });
  }

  buildTemplatesList(data) {
    const templates = data.map((item, index) => {
      return (
        <MenuItem key={`user_key${index}`} value={item.id}>
          {item.current_published_name}
        </MenuItem>
      );
    });

    // templates.unshift(<MenuItem key={`unselectKey`} value="">
    //         <em>None</em>
    //     </MenuItem>)

    this.setState({ templatesList: templates });
  }

  handleClose() {
    this.props.handleClose();
  }

  handleClear() {
    this.setState({
      selectedTemplate: [],
      selectedUser: [],
    });
    this.props.actions.queryWithFilters({}, true);
  }

  handleClickOutside() {
    // if(this.props.open && !this.state.filterSelectorOpen){
    //     this.handleClose()
    // }
  }
}

export default enhanceWithClickOutside(FeedFilters);
